import styled from 'styled-components';
import { Flex, FlexColumn, IconButton } from '@elementary/common-ui/components';

export const Wrapper = styled(FlexColumn)`
  height: 100%;
  gap: 24px;
  position: relative;
  overflow: hidden;
`;

export const Header = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px 8px 16px;
`;

export const HeaderNavigation = styled(Flex)`
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex: 1;
`;

export const BackButton = styled(IconButton)`
  svg path {
    fill: ${({ theme }) => theme.palette.common.gray14} !important;
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.palette.common.black} !important;
  }
`;

export const HeaderActions = styled(Flex)`
  align-items: center;
  gap: 12px;
`;

export const SelectedCountLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.common.gray11};
`;

export const SkipSummary = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.common.gray11};
  padding: 0 16px;
`;

export const DraftPrBanner = styled(Flex)`
  margin: 0 16px;
  padding: 6px 16px;
  align-items: center;
  background: ${({ theme }) => theme.palette.common.gray6};
  border-radius: 8px;
`;

export const DraftPrParagraph = styled(Flex)`
  flex: 1;
  padding: 8px 0;
  align-items: center;
  justify-content: space-between;
`;

export const DraftPrSummary = styled(Flex)`
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.common.black};
`;

export const DraftPrNumbers = styled(Flex)`
  align-items: center;
  gap: 4px;
`;

export const DraftPrDeletions = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.common.red};
`;

export const DraftPrAdditions = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.common.green100};
`;

export const DraftPrLink = styled.a`
  margin-left: auto;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.common.blue4};
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
`;

export const TableContainer = styled(FlexColumn)`
  flex: 1;
  min-height: 0;
  padding: 0 16px 16px 16px;
  z-index: 0;
`;

export const EmptyState = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 16px;
  color: ${({ theme }) => theme.palette.common.gray11};
`;

export const CellFlex = styled(Flex)`
  align-items: center;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;
`;

export const FixedChipWrapper = styled.div`
  flex-shrink: 0;
`;

export const ElasticChipWrapper = styled.div`
  min-width: 0;
  flex: 1;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ShrinkableChipWrapper = styled.div`
  min-width: 0;
  flex-shrink: 1;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
